import React from "react";
import { useHistory } from "react-router-dom";
import './NavigationBar.css';
import '../index.css';
import liwatlogo from '../logo/liwatlogo.svg';
import bookmark from '../logo/Bookmark.svg';
import buy from '../logo/Buy.svg';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';


export function NavigationBar() {
    const history = useHistory();
    const auth = useSelector(state => state.auth)

    const handleLogin = () => {
        if (auth.user != null) {
            history.push('/profile');
        } else {
            history.push('/login');
        }
    };

    return (
        <nav className=" nav navbar fixed-top navbar-expand-lg navbar-light">
            <div className="container-fluid">
                <a href='/'><img src={liwatlogo} alt="" /></a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse ms-3" id="navbarNav">
                    <div className="mr-auto"></div>
                    <ul className="navbar-nav">
                        <li className="nav-item mr-5">
                            <Link to={`/info`} className="navtext">
                                INFO<span className="sr-only">(current)</span>
                            </Link>
                        </li>

                        <li className="nav-item mr-5">
                            <Link to={auth.user != null ? `/itin` : `/login`} className="navtext">
                                ITIN
                        </Link>
                        </li>

                        <li className="nav-item mr-5">
                            <Link to={auth.user != null ? `/` : `/login`} className="navtext">
                                PASS
                        </Link>
                        </li>

                        <li className="nav-item mr-5">
                            <Link to={auth.user != null ? `/` : `/login`} className="navtext">
                                PACK
                        </Link>
                        </li>
                    </ul>
                    <div className="ml-auto"></div>
                    <ul className="navbar-nav">
                        <li style={{ marginRight: "2em" }} className="mt-2">
                            <Link to={auth.user != null ? `/bucketlist` : `/login`}>
                                <img src={bookmark} alt="" />
                            </Link>

                        </li>
                        <li style={{ marginRight: "2em" }} className="mt-2">
                            <Link to={auth.user != null ? `/cart` : `/login`}>
                                <img src={buy} alt="" />
                            </Link>
                        </li>
                        <li>
                            <div className="outline-button" onClick={handleLogin}>
                                {auth.user != null ? "Profile" : "Login"}
                            </div>
                        </li>
                    </ul>

                </div>

            </div>
        </nav>
    );
}

export default NavigationBar;